import { render } from "./UserRegistrationsDialog.vue?vue&type=template&id=436c64c2&scoped=true"
import script from "./UserRegistrationsDialog.vue?vue&type=script&lang=js"
export * from "./UserRegistrationsDialog.vue?vue&type=script&lang=js"

import "./UserRegistrationsDialog.vue?vue&type=style&index=0&id=436c64c2&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436c64c2"]])

export default __exports__